<template>
  <div class="pageContainer">
    <button type="button" @click="next(-1)" v-if="nextLeft">&lt;</button>
    <ul class="ul-cls pagesInner" v-if="pages.length > 1">
      <li v-for="(item, index) in pages"
          :key="index"
          :class="{active:currentPage === item, lineHig:typeof item !==  typeof currentPage}"
          @click="select(item)">{{item}}</li>
    </ul>
    <button type="button" @click="next(1)" v-if="nextRight">&gt;</button>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>

export default {
  props: {
    total: Number,
    current: Number,
  },
  data() {
    return {
      nextLeft: false,
      nextRight: true,
      totalPages: this.total,
      currentPage: this.current,
    };
  },
  watch: {
    total(newVal) {
      this.totalPages = newVal;
      if (this.totalPages === 1) {
        this.nextRight = false;
        this.nextLeft = false;
      } else {
        this.nextRight = true;
      }
    },
    current(newVal) {
      this.currentPage = newVal;
      if (this.currentPage === 1) {
        this.nextLeft = false;
      } else {
        this.nextLeft = true;
      }
    },
  },
  computed: {
    pages() {
      const c = this.currentPage;
      const t = this.totalPages;
      let list = [];
      if (t <= 8) {
        for (let i = 1; i < t + 1; i += 1) {
          list.push(i);
        }
      } else {
        if (c <= 5) {
          list = [1, 2, 3, 4, 5, 6, '...', t];
        } else if (c >= t - 4) {
          list = [1, '...', t - 5, t - 4, t - 3, t - 2, t - 1, t];
        } else {
          list = [1, '...', c - 2, c - 1, c, c + 1, '...', t];
        }
      }
      return list;
    },
  },
  created() {
    if (this.totalPages === 1) {
      this.nextLeft = false;
      this.nextRight = false;
    }
  },
  methods: {
    pageChange(num) {
      if (this.totalPages === 1) {
        this.nextLeft = false;
        this.nextRight = false;
      } else {
        if (num === 1) {
          this.nextLeft = false;
          this.nextRight = true;
        } else if (num === this.totalPages) {
          this.nextLeft = true;
          this.nextRight = false;
        } else {
          this.nextLeft = true;
          this.nextRight = true;
        }
      }
    },
    select(num) {
      this.pageChange(num);
      this.$emit('selectPage', num);
    },
    next(num) {
      const number = this.currentPage + num;
      this.pageChange(number);
      this.$emit('prevOrNext', num);
    },
  },
};
</script>
